import { useEffect, useState } from "react";

import { useApi } from "../../api";

const useDeviceProjects = () => {
  const api = useApi();
  const [projects, setProjects] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/v2/devices/projects")
      .then(response => setProjects(response.data))
      .catch(() => {})
      .then(() => setLoading(false));
  }, [api]);

  return { projects, isLoading };
};

export default useDeviceProjects;
